import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { useCallback, useState } from 'react';
import Workspace from 'src/entities/workspace';
import useUpdateWorkspaceMutation from 'src/new_arch/modules/workspaces/queries/useUpdateWorkspaceMutation';

const useEditWorkspaceName = ( { workspace, readOnly }: { workspace: Workspace, readOnly: boolean } ) => {
	const [ name, setName ] = useState( workspace.name );
	const snackbarSystem = useSnackbarSystem();
	const { mutate: updateWorkspace, isLoading: isSaving } = useUpdateWorkspaceMutation( {
		workspaceID: workspace.id,
		onSuccess: () => {
			snackbarSystem.showSuccessMessage( { title: 'Success! Your changes have been saved!' } );
		},
		onError: () => {
			snackbarSystem.showErrorMessage( { title: 'Oops, something went wrong! Try again.' } );
		}
	} );

	const onInputChange = useCallback( ( event: React.ChangeEvent<HTMLInputElement> ) => {
		setName( event.target.value );
	}, [ setName ] );

	const onSaveClick = useCallback( () => {
		if ( readOnly ) return;
		if ( name === workspace.name ) return;

		updateWorkspace( { name } );
	}, [ updateWorkspace, name, readOnly, workspace.name ] );

	const saveButtonDisabled = readOnly || name === workspace.name;

	return {
		name,
		onInputChange,
		onSaveClick,
		isSaving,
		saveButtonDisabled
	};
};

export default useEditWorkspaceName;
